
<template>
  <v-app >
    <ComBandeau v-if="$root.user && ($root.user.univers =='com' )"/>      
    <TlvBandeau v-if="$root.user && ($root.user.univers =='tlv')"/>  
    <PartnerBandeau v-if="$root.user && ($root.user.univers =='partner')"/>  
    <VadBandeau v-if="$root.user && ($root.user.univers =='vad' )"/>      
    <Bandeau v-if="!$root.user "/>      
    <BandeauToken v-if="$root.token || $root.tokenMode"/>   
    <v-main>
        
        <v-overlay :value="$root.progress">
      <v-progress-circular size="64" indeterminate
        color="red"></v-progress-circular>
    </v-overlay>
         <Connexion v-if="!$root.user && !$root.token" @login = "validateLogin"/>
        <transition  v-if="$root.user" name="fade" mode="out-in">         
          <router-view />
        </transition>  
      </v-main>
  </v-app>
</template>

<script>
import axios from 'axios';
 //import Progress from "./components/Progress"; 
 import ComBandeau from "./components/menu/com/ComBandeau"; 
 import TlvBandeau from "./components/menu/tlv/TlvBandeau"; 
 import PartnerBandeau from "./components/menu/partner/PartnerBandeau"; 
 import VadBandeau from "./components/menu/vad/VadBandeau"; 
 import Bandeau from "./components/menu/Bandeau";  
 import BandeauToken from "./components/menu/BandeauToken";  
 //import HelloWorld from './components/HelloWorld';
 import Connexion from "./components/Connexion";  
 //import LoginForm from "./components/login/LoginForm";  


export default {
  name: "App",

  components: {
     ComBandeau,TlvBandeau,PartnerBandeau,VadBandeau,Bandeau,BandeauToken
    ,Connexion
  }, 

  /* components: {
    HelloWorld
  }, */

  data: () => ({
      showLogin:false,
      homePage:'/com',
      redirect:null
  }),
 beforeMount() {
   axios.interceptors.request.use(config => {
     // Every Axios request should increment our counter
     
     // FOR TOKEN
     let token = localStorage.getItem('access_token');

      if (token) {
        config.headers['Authorization'] = 'Bearer '+ token ;
      }
     return config;
   });
   axios.interceptors.response.use(response => {
     // Every Axios response should decrease our counter
     if(response && response.data && response.data.err== 'appversionerror'){
       sessionStorage.clear();
        this.isAppversionOk();
     }else
        return response;
  }/* FOR TOKEN */
  ,async error=>{
      const originalRequest = error.config;
      if (error.response && error.response.status === 401){
        if(error.response.data && (error.response.data.error_code == 40110 || error.response.data.error_code == 40111) && !originalRequest._retry){
            originalRequest._retry = true;
            localStorage.removeItem('access_token');
            localStorage.removeItem('access_token_expires_at');
            const result = await this.$userService.authenticate();
            localStorage.setItem("access_token",result.params.access_token);            
            localStorage.setItem("access_token_expires_at",result.params.expires_at);

            return axios(originalRequest);
        }else{
          /*console.log(error.response);
          this.$dialog.notify.error(error.response.data.message, {
                position: 'bottom-right',
                timeout: 5000
             })*/

        }

      }
      
        return Promise.reject(error);
   }
  );

   this.init();
   

 },
  mounted:  function () {
    // Écouter les messages provenant de la webview (lorsque postMessage est appelé)
    window.addEventListener("message", this.handleMessage, false);
  },
  beforeDestroy() {
    // Nettoyer l'écouteur quand le composant est détruit
    window.removeEventListener("message", this.handleMessage);
  },
  methods: {
    handleMessage(event) {
      //alert(1)
        // Vérifier la source du message (vous pouvez restreindre cela si nécessaire)
        console.log("handleMessage :",event.origin);
        /*if (event.origin !== "http://localhost") {
          return; // Ne pas traiter les messages d'autres domaines
        }*/
        console.log("event.data :",event.data);
        // Vérifier si le message contient le code d'autorisation
        const  data = event.data;
        if (data && data.action_logout && data.action_logout=='logged_out') {
          this.authCode = data.code; // Stocker le code reçu dans le data
          this.$root.logoutAzureAd();
          // connexion azureAd
          console.log("Code d'autorisation reçu :", this.authCode);
        }
       
      },
     isAppversionOk: async function (){

      await this.$dialog.error({
                  title: 'Erreur',
                  text: 'Une nouvelle version est disponible.',
                  persistent: true,
                  actions: {         
                    Yes: {
                      color: "red",
                      text: "Recharger",
                      handle: () => {
                        window.location.reload(true);
                        //document.location.reload(true);
                      }
                    }
                  }
                });
                /*if (res === undefined) {
                  document.location.reload(true);
                } else {
                  document.location.reload(true);
                }*/
    },
      init: async function(){

        this.$root.uuid = this.$globalService.getUUID(this.$uuid);
        const sessionUser = this.$globalService.getUser();

        let urlParams = new URLSearchParams(window.location.search);
        if(urlParams.has('code') ){
          const code = urlParams.get('code');
          //alert('code: '+code);
          window.opener.postMessage({code:code}, // Le code d'autorisation ou autres données
            "*" // Permet d'envoyer le message à tous les domaines (vous pouvez restreindre cela)
          );

          // Fermer la fenêtre ou rediriger l'utilisateur
          window.close(); // Ferme la webview (si possible)
        }else  if(urlParams.has('action_logout') && urlParams.get('action_logout') == 'logged_out'){
          
          window.opener.postMessage({action_logout:'logged_out'}, // Le code d'autorisation ou autres données
            "*" // Permet d'envoyer le message à tous les domaines (vous pouvez restreindre cela)
          );

          // Fermer la fenêtre ou rediriger l'utilisateur
          window.close(); // Ferme la webview (si possible)
        }else if(urlParams.has('accestoken') && urlParams.has('redirect')){
          this.$root.logoutToken(); 
          this.$root.token = urlParams.get('accestoken');
          this.$root.tokenMode = true;

          //GET JWT TOKEN
          localStorage.removeItem('access_token');
            localStorage.removeItem('access_token_expires_at');
            const result = await this.$userService.authenticate();
            localStorage.setItem("access_token",result.params.access_token);            
            localStorage.setItem("access_token_expires_at",result.params.expires_at);

          if(urlParams.has('callback') )
            this.$root.callback = urlParams.get('callback');

          this.redirect = urlParams.get('redirect');
          var objUser = {'user':new Date().getTime(),token:'cG5pR3RtdklCVGRGL0FzNElOcFJCT3VEY1liMUdldDJJNTEwTGF4U1BuST0='};
          this.validateLogin(objUser);

        }else if(sessionUser != null){
            this.$root.user = sessionUser;
            this.routeHome();

        }else{
          //alert(0);

          
          localStorage.removeItem('access_token');
          localStorage.removeItem('access_token_expires_at');
          await this.$userService.authenticate().then((res) => {
            
            if (res) {
              if (!res.error && res.params) {
                localStorage.setItem("access_token",res.params.access_token);
                localStorage.setItem("access_token_expires_at",res.params.expires_at);

                //login
                this.$webappService.getInfosApp(this.$root.uuid).then(res => { 
                  //this.loadingAzureAD = false;
                  if(res){
                    if (res.err !='error') {
                      //mise en session des params
                      console.log(res.params)
                      this.$root.webappData = res.params;
                        //this.$emit("login", res.params);
                     
                                
                    }else{
                      this.$dialog.error({
                        text: res.err_msg,
                        title: 'Erreur',
                        persistent: false,
                        actions: {
                          false: 'Fermer'
                        }
                      })
                    
                    }
                  }
                }).catch(error=>{
            
                      //this.loadingAzureAD = false;
                      this.$dialog.notify.error(this.$root.errorMessage, {
                                position: 'bottom-right',
                                timeout: 5000
                              })
                    return error;
                })

              }else{
                this.$dialog.notify.error(this.$root.errorMessage, {
                  position: "bottom-right",
                  timeout: 5000,
                });
              
              }
            }
          })
          .catch((error) => {
            //this.loadingAzureAD = false;
            this.$dialog.notify.error(this.$root.errorMessage, {
              position: "bottom-right",
              timeout: 5000,
            });
            return error;
          });
          //afichage de LoginForm
            this.showLogin = true;
            this.$root.user = null;
          
        }
      },
       validateLogin:function(objUser){
        this.$root.user = objUser;
        this.$globalService.setUser(objUser);
        this.routeHome();        
      },
      routeHome: function(){
        if(this.$root.token != null)
          this.$root.menu.homePage = this.redirect;
        else
          this.$root.menu.homePage = '/'+this.$root.user.univers;
        

         this.$router.push({path: this.$root.menu.homePage}).catch(err => {
            // Ignore the vuex err regarding  navigating to the page they are already on.
            if (
               err.name !== 'NavigationDuplicated' &&
               !err.message.includes('Avoided redundant navigation to current location')
            ) {
               // But print any other errors to the console
               throw err;
            }
         });
      }
  }
};
</script>

<style>
   .fade-enter-active,
   .fade-leave-active {
      transition-duration: 0.30s;
      transition-property: opacity;
      transition-timing-function: ease;
   }
   .fade-enter,
   .fade-leave-active {
   opacity: 0;
   }
   .para {
      font-size:1.25rem;
   }
</style>